<template>
  <Main style="overflow-x: clip;">
    <!-- background: rgba(9, 14, 57, 1) -->
    <div slot="main" class="main tanceInfo">
      <div class="content-box">
        <div class="bank-title">
          <Header></Header>
        </div>
        <!-- 添加时间轴 -->

        <ul class="line-box" ref="lineBox">
          <li v-for="(itemList, index) in traceSourceInfo" :key="'key' + index">
            <div class="lis-box-t list-hide " :class="{ 'list-show': showNum >= index }">
              <div :class="itemList.no % 2 == 0 ? 'reset' : ''">
                <p>NO.{{ itemList.no }}</p>
                <img
                  :style="{ transform: (index == 1 || index == 4 || index == 6 || index == 7 || index == 8 || index == 12) ? 'rotateY(180deg)' : '' }"
                  :src="itemList.icon" alt="" />
              </div>
            </div>
            <div class="lis-box-b img-box list-hide " :class="{ 'list-show': showNum >= index }">
              <div v-if="index == 0" class="title-text" style="top:0.22rem">{{ itemList.name }}</div>
              <div v-else-if="index == 1" class="title-text" style="top:0.28rem">{{ itemList.name }}</div>
              <div v-else-if="index == 1" class="title-text" style="top:0.15rem">{{ itemList.name }}</div>
              <div v-else-if="index == 3" class="title-text" style="top:0.25rem">{{ itemList.name }}</div>
              <div v-else-if="index == 5 || index == 11" class="title-text" style="top:0.1rem">{{ itemList.name }}
              </div>
              <div class="title-text" v-else>{{ itemList.name }}</div>

              <button style="cursor:pointer" v-if="itemList.type == 1" @click="openModal(1)">看看养殖户</button>
              <button style="cursor:pointer" v-else-if="itemList.type == 2" @click="openModal(2)">看看企业</button>
              <div class="info-box" v-if="index != 4">

                <div style="margin-top:10px">
                  <p v-for="(item, index) in itemList.data" :key="'value' + index">{{ item.name }}：<span
                      class="title_number">{{ item.value }}</span></p>
                </div>
                <img v-if="itemList.img" :src="itemList.img" alt="" />
              </div>
              <div class="info-box" v-else>
                <div style="margin-top:10px;width: 100%;">
                  <div id="feedChart"></div>
                </div>
              </div>
            </div>
          </li>
          <li>
            <div style="margin-top: -0.9rem;" class="lis-box-t list-hide " :class="{ 'list-show': showNum >= 12 }">
              <div>
                <img src="http://yj.east-mind.com:8097/lib/icon/019.png" style="transform: rotateY(180deg);" alt="" />
                <p>NO.14</p>
              </div>
            </div>
            <div class="lis-box-b list-hide " :class="{ 'list-show': showNum >= 12 }">
              <button @click="openModal(3)" style="cursor:pointer">
                更多<i class="iconfont icon-icon-test"></i>
              </button>
              <div class="title-text" style="top:0.17rem">消费者</div>
              <div class="info-box">
                <div style="width: 100%">
                  <div style="
                  display: flex;
                  justify-content: space-between;
                    align-items: center;
                  ">
                    <div style="
                    font-size: 0.225rem;
                      display: flex;
                      align-items: center;
                      white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      margin-right: 0.2125rem;
                    ">
                      <img style="
                        width: 0.5rem;
                        height: 0.5rem;
                        margin-right: 0.0625rem;
                      " :src="mytraceSourceScan.headPortrait" alt="" />
                      <!-- {{ consumerInfo.nick }} -->
                      {{ mytraceSourceScan.nickName }}
                    </div>
                    <span style="flex: none; margin-right: 10px">
                      <!-- {{
                      consumerInfo.date
                  }} -->
                      {{ mytraceSourceScan.createTime }}
                    </span>
                  </div>
                  <p @click="showModel(mytraceSourceScan)" style="margin-top: 0.15rem; cursor: pointer">
                    <i style="margin-right: 0.0375rem" class="el-icon-location"></i>
                    {{ mytraceSourceScan.scanAddress }}
                    <!-- {{ consumerInfo.address }} -->
                  </p>
                </div>
              </div>
            </div>
          </li>

        </ul>
        <div class="mask-box" v-show="modalShow1">
          <div class="modal-box modal-box-1">
            <span class="text-info" style="top: 0.16rem;">看看养殖户</span>
            <div style="margin-top: .3rem;">
              <i @click="closeModal(1)" class="el-icon-close icon-close"></i>
              <div style="margin-right: .15rem;">
                <div style="margin-bottom: .5rem; font-size: .2rem;height: 3.4rem" class="area-box">
                  <!-- <span class="title-text">牧民信息</span> -->
                  <span class="card_item"><span class="card"></span>看看养殖户</span>
                  <div class="info_item">
                    <div class="img_box">
                      <img src="../../assets/people.png" alt="">
                    </div>
                    <div class="info_ info_n">
                      <div>
                        <span>姓名：</span>
                        <span>高少军</span>
                      </div>
                      <div>
                        <span>联系电话：</span>
                        <!-- <span>135****9898</span> -->
                        <span>155****5511</span>
                      </div>
                      <!-- <div>
                        <span>身份证号：</span>
                        <span>1306211990****0610</span>
                      </div> -->
                      <div>
                        <span>养殖方式：</span>
                        <span>自繁自养</span>
                      </div>
                    </div>
                    <div class="info_ info_a">
                      <div>
                        <span>性别：</span>
                        <span>男</span>
                      </div>
                      <div>
                        <span>民族：</span>
                        <span>汉族</span>
                      </div>
                      <div>
                        <span>所在区域：</span>
                        <span>通辽市丰田镇万家屯村</span>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <div class="area-box" style="margin-top: .6rem;">
                  <span class="card_item"><span class="card"></span>牧民信贷</span>
                  <div id="myChart2" style="height: 3.4rem"></div>
                </div> -->
              </div>
              <div>
                <div style="" class="area-box">
                  <!-- <span class="title-text">物联设备</span> -->
                  <span class="card_item"><span class="card"></span>物联设备<span @click="herdBtn"
                      style="margin-left: 5.8rem; cursor: pointer;"> <i class="el-icon-sort"></i> 切换</span> </span>
                  <div class="position-relative" ref="device_box">
                    <p class="time" style="top: 4px;left: 20px;">{{ nowTimer }}</p>
                    <!-- <video autoplay canplay="canplay" muted loop :src="personVideoUrl"></video> -->
                    <img v-if="enterShow1" src="../../assets/tl/herd.jpg"
                      style=" width: 100%; height: 4.4rem;margin-left:.4rem" alt="">
                    <div v-else id="myPlayer1" style=" width: 100%; height: 4.4rem;display:block;margin-left:.4rem"></div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
        <div class="mask-box" v-show="modalShow2">
          <div class="modal-box modal-box-1">
            <span class="text-info" style="top: 0.2rem;">企业信息</span>
            <div style="margin-top: .3rem;">
              <i @click="closeModal(2)" class="el-icon-close icon-close"></i>
              <div style="margin-right: .15rem;">
                <div style="margin-bottom: .5rem; font-size: .2rem;height: 3.4rem" class="area-box">
                  <!-- <span class="title-text">牧民信息</span> -->
                  <span class="card_item"><span class="card"></span>企业信息</span>
                  <div class="info_item">
                    <div class="img_box">
                      <!-- <img src="../../assets/people.png" alt=""> -->
                    </div>
                    <div class="info_ info_n">
                      <div>
                        <span>企业名称：</span>
                        <span>内蒙古草原牛王肉业有限公司</span>
                      </div>
                      <div>
                        <span>企业地址：</span>
                        <span>内蒙古通辽市开鲁县开鲁镇梨树村08-1203588号</span>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
              <div>
                <div style="" class="area-box">
                  <!-- <span class="title-text">物联设备</span> -->
                  <span class="card_item" style="width: 100%;"><span class="card">
                    </span>物联设备 <span @click="enterBtn" style="margin-left: 5.8rem; cursor: pointer;"> <i
                        class="el-icon-sort"></i> 切换</span> </span>
                  <div class="position-relative" ref="device_box">
                    <!-- <p class="time">{{ nowTimer }}</p> -->
                    <p class="time" style="top: 12px;left: 20px;color: #000;">{{ nowTimer }}</p>
                    <img v-if="enterShow" src="../../assets/tl/video-img.jpg"
                      style=" width: 100%; height: 4.4rem;margin-left:.4rem" alt="">
                    <!-- <img :src="videoImg" style="width:100%;height:6rem;display:block;margin-left:.4rem" alt=""> -->
                    <div v-else id="myPlayer" style=" width: 100%; height: 4.4rem;display:block;margin-left:.4rem"></div>
                    <!-- <video autoplay="autoplay" canplay="canplay" muted loop :src="personVideoUrl"></video> -->
                  </div>
                </div>
                <!-- <div class="area-box">
                  <span class="card_item"><span class="card"></span>牧民资产</span>
                  <div style="display: flex;justify-content: space-around;">
                    <div id="myChart3" style="width: 60%;height:2.8rem; flex: none"></div>
                    <div id="myChart4" style="width: 60%;height:2.8rem;  flex: none"></div>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </div>

        <div class="model_box" v-show="mapListShow">
          <div class="model_content">
            <div class="top_box">
              <div class="left_box">
                <div class="saoma" :class="{ 'active1': active == '2' }" @click="openModal(4)"><span>扫码列表</span> </div>
                <div class="hotMap" :class="{ 'active': active == '1' }" @click="showModelHeatMap(traceSourceScan)">
                  <span>消费者热力图</span>
                </div>
              </div>
              <i @click="close" class="el-icon-close"></i>
            </div>
            <div class="line_box" v-show="mapShow">
              <div class="map_box">
                <div class="bm-view" id="container"></div>
              </div>
              <div class="bottom_box"></div>
            </div>
            <div class="saoma_list consumer-list" v-show="modalShow3">
              <table style="background: rgba(255,255,255,0.05);border-collapse: collapse;">
                <tr>
                  <th>昵称</th>
                  <th>头像</th>
                  <th>扫码时间</th>
                  <th>扫码位置</th>
                </tr>
              </table>
              <!-- max-height -->
              <div class="tableoOut" ref="tableoOut" style="margin-top: .15rem;">
                <div class="tableBox" ref="tableBox" :style="{ height: tableHei }">
                  <table ref="tableInner" style="border-collapse: collapse;" v-loading="loading1"
                    element-loading-text="数据加载中" class="tableInner consumer-lis" :class="{
                      'consumer-lis-animate': isAnimate,
                      'margin-t-35': isAnimate,
                    }">
                    <tbody>

                      <tr v-for="item in traceSourceScan" :key="item.id">
                        <td>{{ item.nickName }}</td>
                        <td><img :src="item.headPortrait" /></td>
                        <td>{{ item.createTime }}</td>
                        <td @click="modelAdress(item)" style="cursor: pointer">
                          {{ item.scanAddress }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

              </div>
            </div>
          </div>
        </div>

        <!-- <HeatMap style="position: fixed;" ref="heatmap" @saomaList="openModal(4)" @exit="openModal_">
        </HeatMap> -->
        <PitchMap v-if="pichMapShow" style="position: fixed; " ref="pitchMap" :option="currentAddress"
          @closePichMap="closePichMap"></PitchMap>

        <!--  :heatMapData="heatMapData" -->
        <button @click="return_" style="bottom: calc(20% + 60px);" class="pos-btn"><img src="../../assets/return_.png"
            alt=""></button>
        <button @click="top_" class="pos-btn"><img src="../../assets/top.png" alt=""></button>
        <img style="width:3rem;height: 3rem;position: fixed;right:10%;top:20%" src="../../assets/tl/source.png" alt="">
        <video src="../../assets/66.mp4" muted autoplay="autoplay" loop="loop" class="video_bg"></video>
      </div>
    </div>
  </Main>
</template>

<script>
import Main from "../../components/main.vue";
import PitchMap from "../../components/pitchMap.vue";
// import HeatMap from "../../components/heatMap.vue";
// import Header from "../../components/header.vue";
// import AMapLoader from '@amap/amap-jsapi-loader';
// import dataJson from './data.js'
import infoData from '../industry/infoData'
import Header from "../industry/components/head.vue";
export default {
  components: {
    Main,
    PitchMap,
    // HeatMap,
    Header
  },
  data() {
    return {
      mapListShow: false,
      mapShow: false,//消费者热力图
      data: [],
      map: null,
      centers: {
        lng: 104.114129,
        lat: 38.450339
      },
      heatmap: {},
      pichMapShow: false,//地址地图
      userInfo: {},
      bankInfo: {},
      showNum: "",
      consumerInfo: {
        head: "",
        nick: "",
        date: "",
        address: "",
        lat: "",
        lng: "",
      },
      active: '2',
      traceSourceScan: [],
      mytraceSourceScan: {},//展示更多信息
      modalShow1: false,
      modalShow2: false,
      modalShow3: false,
      isAnimate: false,
      currentAddress: {},
      center: {},
      markerPo: {},
      heatMapData: [],
      hotMapData: [],
      traceSourceInfo: [],
      itemNO: [],
      nowTimer: '',
      personVideoUrl: '',
      CompanyId: '',
      headerInfo: {},
      loading1: false,
      input: '',
      videoImg: require('../../assets/pic.jpg'),
      // ----------------
      tableHei: 'auto',
      timers: null,
      size: 0,
      stopSign: true, // 判断定时器是否停止标识
      stepTime: null, // 改为全局定时器
      decoder: {},
      decoder1: {},
      enterShow: false,
      enterShow1: false,
      username: null,

    };
  },
  watch: {},
  destroyed() {
    // console.log(223);
    // window.localStorage.removeItem('TL')
  },
  mounted() {

    // this.headerInfo = {
    //   name: window.localStorage.getItem('screenName')
    // }

    this.roll()
    const that = this;
    // 增加浏览器激活状态判断。非激活状态为onblur
    window.onfocus = function () {
      if (that.$refs.tableBox) {
        const tableBox = that.$refs.tableBox;
        const sT = tableBox.scrollTop;
        console.log("激活状态！")
        if (!that.stopSign) {
          tableBox.scrollTop = Math.round(sT / 50) * 50;
          clearInterval(that.stepTime);
        }
      }

    }
    // this.getTable();

    this.getFeedChart()
  },
  updated() {

  },
  created() {
    // 处理通辽大屏进入页面逻辑
    this.getToken()
    this.CompanyId = this.$route.query.CompanyId
    this.userInfo = JSON.parse(window.localStorage.getItem("NMYDATAUSERINFO"));
    // 获取溯源信息
    this.getTraceInfo()
    // this.getTraceSourceCompanyInfo(this.CompanyId);
    // this.getTraceSourceScan(this.CompanyId);
    // this.getTraceSourceInfo();
  },
  methods: {
    getToken() {
      window.localStorage.setItem('TL', 'tldp')
      console.log(process.env.ENV, process.env.NODE_ENV);
      // if (process.env.NODE_ENV == 'development') {
      //     this.username = 'nx-dp'
      // } else {
      //     this.username = 'dptest-admin'
      // }
      // this.username = 'nx-dp'
      // this.$http({
      //   url: '/xmbapp-service/user/login',
      //   //请求方式
      //   method: 'post',
      //   //传递的参数
      //   data: {
      //     username: this.username,
      //     password: '123456',
      //     extsysCode: 100000010
      //   },
      // }).then(res => {
      //   this.flag = true
      //   const data = res.data;
      //   if (res.data.code === 200) {
      //     window.localStorage.setItem('NMYDATAAUSERNAME', this.username)
      //     window.localStorage.setItem('NMYDATAASSTSTOKEN', data.result.token)
      //     window.localStorage.setItem('NMYDATAUSERINFO', JSON.stringify(data.result.sysUser))

      //   } else {
      //     this.$message.error(data);
      //   }
      //   // this.userInfo = JSON.parse(window.localStorage.getItem("NMYDATAUSERINFO"));

      // })
    },
    // 牧民切换
    herdBtn() {
      // this.$message.warning('暂无其他视频！')
      this.enterShow1 = !this.enterShow1
      if (this.enterShow1) {
        this.stop1()
      }
      if (!this.enterShow1) {
        setTimeout(() => {
          this.$nextTick(() => {
            this.setCameras1()
          })
        }, 10)
      }
    },
    // 企业视频图片切换
    enterBtn() {
      this.enterShow = !this.enterShow
      if (this.enterShow) {
        this.stop()
      }
      if (!this.enterShow) {
        setTimeout(() => {
          this.$nextTick(() => {
            this.setCameras()
          })
        }, 10)
      }
    },
    stop() {
      // 企业视频停止播放
      const _this = this
      if (_this.decoder && _this.decoder.stop) {
        _this.decoder.stop()
        _this.decoder = {}
        // _this.camerasListItem = {}
        document.getElementById('myPlayer').innerHTML = ''
      }
    },
    stop1() {
      // 企业视频停止播放
      const _this = this
      if (_this.decoder1 && _this.decoder1.stop) {
        _this.decoder1.stop()
        _this.decoder1 = {}
        // _this.camerasListItem = {}
        document.getElementById('myPlayer1').innerHTML = ''
      }
    },
    getFeedChart() {
      setTimeout(() => {
        this.$nextTick(() => {
          // 基于准备好的dom，初始化echarts实例
          let myChart = this.$echarts.init(document.getElementById("feedChart"));
          // 绘制图表
          myChart.setOption({
            color: ["#00E0DB", "#2C76FE"],
            tooltip: {
              trigger: "axis",
              backgroundColor: "rgba(255,255,255,.9)",
              textStyle: {
                color: "#555",
              },
            },
            grid: {
              left: "3%",
              right: "4%",
              bottom: "14%",
              top: "25%",
              containLabel: true,
            },
            xAxis: {
              type: "category",
              boundaryGap: true,
              data: [
                "01月",
                "02月",
                "03月",
                "04月",
                "05月",
                "06月",
                "07月",
              ],
              axisLabel: {
                color: '#FFFFFF',
              },
              axisLine: {
                show: true, // X轴 网格线 颜色类型的修改
                lineStyle: {
                  color: '#075F73',
                },
              },
              axisTick: {
                // X轴线 刻度线
                show: true,
                inside: true,
                alignWithLabel: true
              },
            },
            yAxis: {
              type: "value",
              name: '单位/kg',
              nameTextStyle: {
                color: '#FFFFFF',
                padding: [3, 20, 0, 0],
                lineHeight: 45,
                // align:'left'
              },
              splitNumber: 3,
              axisLine: {
                show: false, // Y轴线
                lineStyle: {
                  color: 'rgba(85, 193, 255, 1)',
                },
              },
              splitLine: {
                lineStyle: {
                  type: 'dashed',
                  color: 'rgba(255,255,255,0.05)'
                }
              },
              axisLabel: {
                color: '#FFFFFF',
              },
            },
            legend: {
              data: [""],
              icon: "roundRect",
              top: "1%",
              right: "3%",
              itemWidth: 8,
              itemHeight: 8,
              padding: [10, 0, 0, 0],
              textStyle: { color: ["#00E0DB", "#2C76FE"] },
            },
            series: [
              {
                name: "",
                type: "line",
                stack: "总量",
                data: [
                  400, 450, 510, 580, 650, 730, 800
                ],
                lineStyle: {
                  color: "#00E0DB",
                },
              },
            ],
          });
        });
      }, 1000)
    },
    close() {
      clearInterval(this.stepTime);
      this.stepTime = null
      console.log('关闭')
      this.mapListShow = false
      this.scrolling()
      this.roll()
      // this.mapShow=false
    },
    initAMap() {
      // AMapLoader.reset();
      // AMapLoader.load({
      //   key: '5a0c1eeb3c3665e4e06c3855b5688a1a',  //设置您的key
      //   version: "2.0",
      //   plugins: ['AMap.ToolBar', 'AMap.Driving'],
      //   // AMapUI: {
      //   //     version: "1.1",
      //   //     plugins: [],
      //   // },
      //   Loca: {
      //     version: "2.0"
      //   },
      // }).then((AMap) => {
      //   this.map = new AMap.Map("container", {
      //     viewMode: "2D",
      //     zoom: 4.3,
      //     zooms: [2, 22],
      //     center: [this.centers.lng, this.centers.lat],
      //   });
      //   this.map.setDefaultCursor('pointer');
      //   // 热力图配置
      //   // let vm = this;
      //   // vm.heatmap = {};
      //   this.map.plugin(["AMap.HeatMap"], () => {
      //     //初始化heatmap对象
      //     this.heatmap = new AMap.HeatMap(this.map, {
      //       radius: 18, //给定半径
      //       opacity: [0, 0.8]
      //     });
      //     //设置数据集：该数据为北京部分“公园”数据
      //     this.heatmap.setDataSet({
      //       data: this.data,
      //       max: 60
      //     });
      //   });
      // }).catch(e => {
      //   console.log(e);
      // })
      this.map = new AMap.Map("container", {
        viewMode: "2D",
        zoom: 4.3,
        zooms: [2, 22],
        center: [this.centers.lng, this.centers.lat],
      });
      this.map.setDefaultCursor('pointer');
      // 热力图配置
      // let vm = this;
      // vm.heatmap = {};
      this.map.plugin(["AMap.HeatMap"], () => {
        //初始化heatmap对象
        this.heatmap = new AMap.HeatMap(this.map, {
          radius: 18, //给定半径
          opacity: [0, 0.8]
        });
        //设置数据集：该数据为北京部分“公园”数据
        this.heatmap.setDataSet({
          data: this.data,
          max: 60
        });
      });
    },
    // 获取溯源信息
    getTraceInfo() {
      this.$http({
        // url: 'screenapp-service/baseBigScreen/select',
        url: 'screenapp-service/screenGoodsTraceSource/select',
        //请求方式
        method: 'post',
        //传递的参数
        data: {
          traceSourceCode: "abc",
          deptId: this.userInfo.dept.deptId,
          parentId: "0",
          menuMark: "6"
        },
      }).then(res => {
        const data = res.data;
        if (res.data.code === 200) {
          const screenData = JSON.parse(data.result.screenData)
          console.log(screenData);
          // this.traceSourceScan = screenData.userList.data
          this.consumerInfo = screenData.userList.data[0];
          // this.traceSourceInfo = screenData.chartInfo.data;
          this.traceSourceInfo = infoData;
          console.log(this.traceSourceInfo, '34343');
          this.getTraceSourceScan(this.CompanyId);
          // this.getTraceSourceCompanyInfo(this.CompanyId);
          this.getTraceSourceInfo();
        }
      },
      )
    },
    timer() {
      let date = new Date();
      this.nowTimer = date.toLocaleString();
    },
    listShow() {
      const docScrollTop = document.documentElement.scrollTop - 200;
      for (let i = 0; i < this.elOffsetTopArr.length; i++) {
        if (
          this.elOffsetTopArr[i] >= docScrollTop &&
          this.elOffsetTopArr[i] < docScrollTop + window.innerHeight
        ) {
          this.showNum = i >= this.showNum ? i : this.showNum;
        }
      }
    },
    openModal_() {
      this.mapShow = false
    },
    openModal(a) {
      // this.$echarts.init(document.getElementById("myChart2")).dispose();
      // this.$echarts.init(document.getElementById("myChart3")).dispose();
      // this.$echarts.init(document.getElementById("myChart4")).dispose();
      // this.$echarts.init(document.getElementById("myChart5")).dispose();
      // this.$echarts.init(document.getElementById("myChart6")).dispose();
      // this.$echarts.init(document.getElementById("myChart7")).dispose();
      if (a == 1) {
        this.modalShow1 = true;
        // this.herdsmanInit();
        this.getTraceSourceVideo(1);
        // this.queryVideo(1);
        this.setCameras1()
      } else if (a == 2) {
        this.modalShow2 = true;
        // 企业视频
        this.setCameras()

        // this.companyInit();
        // this.queryVideo(2);
        this.getTraceSourceVideo(2);
      } else if (a == 3) {
        this.active = '2'
        this.mapListShow = true
        this.mapShow = false
        this.modalShow3 = true
        // this.consumerRoll()
        // this.getTraceSourceScan()
        this.consumerRoll();
        this.getTable()
        // this.traceSourceScan=JSON.parse(window.localStorage.getItem('tRACESOURCESCAN'))
        // this.mytraceSourceScan =  this.traceSourceScan[0]
        this.closeModal(4);
      } else if (a == 4) {
        this.mapShow = false
        this.modalShow3 = true
        this.$nextTick(() => {
          this.active = '2'
        })
        // this.closeModal(4);
      }
      var mo = function (e) { e.preventDefault() }
      document.body.style.overflow = 'hidden'
      document.addEventListener('touchmove', mo, false)
    },
    showModel(consumerInfo) {
      this.pichMapShow = true
      this.$nextTick(() => {
        this.$refs.pitchMap.showModel();
      })
      this.currentAddress = consumerInfo;
    },
    // 关闭扫码地址地图
    closePichMap() {
      this.pichMapShow = false
      this.mapShow = false
      clearInterval(this.stepTime);
      this.stepTime = null
      this.roll()
    },
    roll() {
      this.$nextTick(() => {
        setInterval(this.timers, 1000);
        let this_ = this;
        let nodeList = this.$refs.lineBox.childNodes;
        this.elOffsetTopArr = [];
        for (let i = 0; i < nodeList.length; i++) {
          this_.elOffsetTopArr.push(nodeList[i].offsetTop);
        }
        this.listShow();
        // 滚动时监听
        window.onscroll = function () {
          console.log('页面滚动')
          this_.listShow();
        };
      })
    },
    showModelHeatMap(val) {
      console.log(val, '111111');
      this.active = '1'
      this.data = JSON.parse(window.localStorage.getItem('HEATMAPDATA'))
      this.mapShow = true
      this.$nextTick(() => {
        this.NoScrolling()
        this.initAMap()
      })
      // console.log(val, 'ha');
      // for (let i = 0; i < val.length; i++) {
      //   let item = val[i];
      //   this.heatMapData.push({ "lng": item.longitude, "lat": item.latitude, "count": 30 })
      // }
      // this.heatMapData = this.hotMapData;
      // console.log(this.heatMapData, 'this.heatMapData');
      this.closeModal(3);
      // this.$refs.heatmap.heatMapShowModel();
      // this.heatMapData = [
      //   { lng: 116.418261, lat: 39.921984, count: 2 },
      //   { lng: 116.05, lat: 43.93, count: 200 },
      //   { lng: 116.41, lat: 39.91, count: 67 },
      //   { lng: 116.65, lat: 39.91, count: 18 },
      //   { lng: 119.35, lat: 39.11, count: 28 },
      //   { lng: 116.65, lat: 39.91, count: 48 },
      //   { lng: 117.15, lat: 39.51, count: 108 },
      //   { lng: 118.35, lat: 39.31, count: 118 },
      //   { lng: 113.95, lat: 40.31, count: 118 },
      //   { lng: 100.35, lat: 40.21, count: 118 },
      //   { lng: 101.45, lat: 40.31, count: 118 },
      //   { lng: 102.55, lat: 40.51, count: 218 },
      //   { lng: 103.65, lat: 40.61, count: 218 },
      //   { lng: 105.75, lat: 38.31, count: 118 },
      //   { lng: 107.75, lat: 35.31, count: 118 },
      //   { lng: 110.75, lat: 31.31, count: 118 },
      //   { lng: 110.75, lat: 40.31, count: 118 },
      //   { lng: 110.75, lat: 41.31, count: 118 },
      //   { lng: 110.75, lat: 42.31, count: 118 },
      //   { lng: 110.75, lat: 42.91, count: 118 },
      //   { lng: 116.65, lat: 31.91, count: 180 },
      //   { lng: 116.65, lat: 28.91, count: 180 },
      //   { lng: 115.65, lat: 27.91, count: 180 },
      //   { lng: 114.65, lat: 26.91, count: 180 },
      //   { lng: 116.65, lat: 31.91, count: 180 },
      //   { lng: 101.65, lat: 27.91, count: 180 },
      //   { lng: 102.65, lat: 26.91, count: 180 },
      //   { lng: 103.65, lat: 31.91, count: 180 },
      //   { lng: 104.65, lat: 27.91, count: 180 },
      //   { lng: 105.65, lat: 26.91, count: 180 },
      //   { lng: 106.65, lat: 31.91, count: 180 },
      // ]; 
      // this.heatMapData = this.hotMapData;
      // console.log(this.hotMapData, 123)
    },
    // getTraceSourceCompanyInfo() {
    //   this.$http
    //     .get("https://www.91xumu.com/nxm-app/cbCodeScanningRecord/nlg/queryPage?p=1&r=1000", {

    //     })
    //     .then((res) => {
    //       if (res.data.stautscode === 200) {
    //         const consumerList = res.data.data.CbCodeScanningRecordVoListPage.list;
    //         // this.consumerInfo = this.consumerList[0] || this.consumerInfo;
    //         console.log(consumerList,'consumerList');
    //         for (let i = 0; i < consumerList.length; i++) {
    //           let item = consumerList[i];
    //           this.hotMapData.push({ "lng": item.lng, "lat": item.lat, "count": 30 })
    //         }
    //         // this.hotMapData = JSON.parse(res.data.data.hotMapData);
    //       }
    //     });
    //   // this.hotMapData = dataJson.dataInfo.data.hotMapData
    // },
    return_() {
      this.$router.go(-1);
    },
    top_() {
      window.scrollTo(0, 0);
      this.showNum = 0;
    },
    closeModal(a) {
      if (a == 1) {
        this.modalShow1 = false;
      } else if (a == 2) {
        this.modalShow2 = false;
        // 企业视频停止播放
        this.stop()
      } else if (a == 3) {
        this.modalShow3 = false;
        clearInterval(this.time);
        // this.traceSourceScan = []
      } else if (a == 4) {
        this.modalShow4 = false;
      }
      var mo = function (e) {
        e.preventDefault()
      }
      document.body.style.overflow = ''// 出现滚动条
      document.removeEventListener('touchmove', mo, false)
    },
    herdsmanInit() {
      this.$nextTick(() => {
        // 基于准备好的dom，初始化echarts实例
        let myChart2 = this.$echarts.init(document.getElementById("myChart2"));
        // 绘制图表
        myChart2.setOption({
          color: ["#00E0DB", "#2C76FE"],
          tooltip: {
            trigger: "axis",
            backgroundColor: "rgba(255,255,255,.9)",
            textStyle: {
              color: "#555",
            },
          },
          grid: {
            left: "3%",
            right: "4%",
            bottom: "14%",
            top: "25%",
            containLabel: true,
          },
          xAxis: {
            type: "category",
            boundaryGap: true,
            data: [
              "6月",
              "7月",
              "8月",
              "9月",
              "11月",
              "12月",
              "1月",
              "2月",
              "3月",
              "4月",
              "5月",
            ],
            axisLabel: {
              color: '#FFFFFF',
            },
            axisLine: {
              show: true, // X轴 网格线 颜色类型的修改
              lineStyle: {
                color: '#075F73',
              },
            },
            axisTick: {
              // X轴线 刻度线
              show: true,
              inside: true,
              alignWithLabel: true
            },
          },
          yAxis: {
            type: "value",
            name: '数量',
            nameTextStyle: {
              color: '#FFFFFF',
              padding: [3, 40, 0, 0],
              lineHeight: 45,
              // align:'left'
            },
            splitNumber: 3,
            axisLine: {
              show: false, // Y轴线
              lineStyle: {
                color: 'rgba(85, 193, 255, 1)',
              },
            },
            splitLine: {
              lineStyle: {
                type: 'dashed',
                color: 'rgba(255,255,255,0.05)'
              }
            },
            axisLabel: {
              color: '#FFFFFF',
            },
          },
          legend: {
            data: ["总消费", "贷款"],
            icon: "roundRect",
            top: "1%",
            right: "3%",
            itemWidth: 8,
            itemHeight: 8,
            padding: [10, 0, 0, 0],
            textStyle: { color: ["#00E0DB", "#2C76FE"] },
          },
          series: [
            {
              name: "总消费",
              type: "line",
              stack: "总量",
              data: [
                7, 6.9, 9.5, 14.5, 18.4, 21.5, 25.2, 26.5, 23.3, 18.3, 13.9,
                9.6,
              ],
              lineStyle: {
                color: "#00E0DB",
              },
            },
            {
              name: "贷款",
              type: "line",
              stack: "总量",
              data: [
                3.9, 4.2, 5.7, 8.5, 11.9, 15.2, 17, 16.6, 14.2, 10.3, 6.6, 4.8,
              ],
              lineStyle: {
                color: "#2C76FE",
              },
            },
          ],
        });

        // 基于准备好的dom，初始化echarts实例
        let myChart3 = this.$echarts.init(document.getElementById("myChart3"));
        // 绘制图表
        myChart3.setOption({
          tooltip: {
            trigger: "item",
            formatter: "{b}: {c}%",
            backgroundColor: 'rgba(255,255,255,0.8)',
            borderColor: '#292929',
            borderWidth: 1,
            textStyle: {
              color: '#050F37',
            },
            padding: 5,
            extraCssText: "box-shadow: rgba(47, 244, 225, 0.5) 0px 0px 10px;",
          },
          legend: {
            data: ["基础母牛", "育肥牛", "犊牛"],
            icon: "circle",
            bottom: -5,
            textStyle: {
              color: '#00E0DB',
            },
            itemWidth: 10,
            itemHeight: 10,
          },
          series: [
            {
              color: ["#3AFFFB", "#FFC700", "#165DFF", "#7239EA", "#FF7300"],
              name: "牧民资产",
              type: "pie",
              radius: ['40%', '70%'],
              bottom: 10,
              // itemStyle: {
              //   borderWidth: 1,
              //   borderColor: "#fff",
              // },
              label: {
                show: true,
                position: 'outside',
                color: '#FFFFFF',
                padding: [0, -20],
                alignTo: 'labelLine',
                formatter: "{d}%\n{b}",
              },
              emphasis: {
                label: {
                  show: true,
                  // fontSize: '40',
                  // fontWeight: 'bold'
                }
              },
              labelLine: {
                show: true,
                length: 10,
                length2: 20,
                lineStyle: {
                  color: '#73c0de',
                }
              },
              data: [
                { value: 36.0, name: "基础母牛" },
                { value: 46.67, name: "育肥牛" },
                { value: 17.33, name: "犊牛" },
              ],
              // hoverAnimation: false,
            },
          ],
        });

        // 基于准备好的dom，初始化echarts实例
        let myChart4 = this.$echarts.init(document.getElementById("myChart4"));
        // 绘制图表
        myChart4.setOption({
          tooltip: {
            trigger: "item",
            formatter: "{b}: {c}%",
            backgroundColor: 'rgba(255,255,255,0.8)',
            borderColor: '#292929',
            borderWidth: 1,
            textStyle: {
              color: '#050F37',
            },
            padding: 5,
            extraCssText: "box-shadow: rgba(47, 244, 225, 0.5) 0px 0px 10px;",
          },
          legend: {
            data: ["基础母羊", "种公羊", "羔羊"],
            icon: "circle",
            bottom: -5,
            textStyle: {
              color: '#00E0DB',
            },
            itemWidth: 10,
            itemHeight: 10,
          },
          series: [
            {
              color: ["#3AFFFB", "#FFC700", "#165DFF", "#7239EA", "#FF7300"],
              name: "牧民资产",
              type: "pie",
              radius: ['40%', '70%'],
              bottom: 10,
              // itemStyle: {
              //   borderWidth: 1,
              //   borderColor: "#fff",
              // },
              label: {
                show: true,
                position: 'outside',
                color: '#FFFFFF',
                padding: [0, -20],
                alignTo: 'labelLine',
                formatter: "{d}%\n{b}",
              },
              emphasis: {
                label: {
                  show: true,
                  // fontSize: '40',
                  // fontWeight: 'bold'
                }
              },
              labelLine: {
                show: true,
                length: 10,
                length2: 20,
                lineStyle: {
                  color: '#73c0de',
                }
              },
              data: [
                { value: 73.63, name: "基础母羊" },
                { value: 1.1, name: "种公羊" },
                { value: 25.27, name: "羔羊" },
              ],
              // hoverAnimation: false,
            },
          ],
        });
      });
    },
    getTraceSourceScan() {
      // this.$http
      //   .get("/api.asmx/TraceSourceScan", {
      //     params: {
      //       companyid: id,
      //     },
      //   })
      //   .then((res) => {
      //     if (res.data.code === 200) {
      //       this.traceSourceScan = res.data.data;
      //       this.consumerInfo = res.data.data[0];
      //       this.consumerRoll();
      //     }
      //   });

      // this.traceSourceScan = dataJson.userList.data
      // this.consumerInfo = dataJson.userList.data[0];
      this.$http({
        // url: 'screenapp-service/baseBigScreen/select',
        url: 'screenapp-service/screenScanRecord/select',
        //请求方式
        method: 'post',
        //传递的参数
        // data: {
        //   traceSourceCode: "abc",
        //   deptId: this.userInfo.dept.deptId,
        //   parentId: "0",
        //   menuMark: "6"
        // },
      }).then(res => {
        const data = res.data;
        if (res.data.code === 200) {
          console.log(data.result, 'data.result');
          this.traceSourceScan = data.result
          this.traceSourceScan.forEach((item) => {
            this.heatMapData.push({ "lng": item.latitude, "lat": item.longitude, "count": 30 })
          })
          this.mytraceSourceScan = data.result[0]
          // window.localStorage.setItem('tRACESOURCESCAN',JSON.stringify(this.traceSourceScan))
          if (JSON.parse(window.localStorage.getItem('HEATMAPDATA')) && JSON.parse(window.localStorage.getItem('HEATMAPDATA')).length > 0) {
            return
          } else {
            window.localStorage.setItem('HEATMAPDATA', JSON.stringify(this.heatMapData))//热力图数据
          }
        }
      },
      )
      // this.consumerRoll();
      // this.getTable()
    },
    // =================
    getTable() {
      const outHei = this.$refs.tableoOut.clientHeight - 60;
      this.size = Math.floor(outHei / 50);
      this.tableHei = this.size * 50 + 'px';
      this.scrolls();
    },
    stepScroll() {
      const that = this;
      const step = 50;
      let num = 0;
      const tableBox = this.$refs.tableBox;
      // 改为全局定时器，且在调用前先进行清空
      clearInterval(this.stepTime);
      this.stepTime = setInterval(() => {
        that.stopSign = false;
        // console.log('定时器任务')
        num += 2;
        if (num > step) {
          num = 0;
          clearInterval(that.stepTime);
          that.stopSign = true;
        } else {
          if (tableBox == undefined) return
          tableBox.scrollTop += 2;
        }
      }, 1000 / 60);
    },
    scrolls() {
      const that = this;
      const tableBox = this.$refs.tableBox;
      const tableInner = this.$refs.tableInner;
      clearInterval(this.timers);
      this.timers = setInterval(() => {
        // 修改定时器结束判断条件
        if (tableBox.scrollTop >= tableInner.scrollHeight) {
          tableBox.scrollTop = 0;
        }
        that.stepScroll();
      }, 2000);
    },
    // 循环播放
    consumerRoll() {
      // if (this.traceSourceScan.length > 5) {
      //   this.time = setInterval(() => {
      //     this.isAnimate = true;
      //     setTimeout(() => {
      //       this.traceSourceScan.push(this.traceSourceScan[0]);
      //       this.isAnimate = false;
      //       this.traceSourceScan.shift();
      //     }, 1900);
      //   }, 2000);
      // }
    },
    companyInit() {
      this.$nextTick(() => {
        // 基于准备好的dom，初始化echarts实例
        let myChart5 = this.$echarts.init(document.getElementById("myChart5"));
        // 绘制图表
        myChart5.setOption({
          color: ["#2C76FE", "#00E0DB"],
          tooltip: {
            trigger: "axis",
            padding: [5, 20],
            backgroundColor: 'rgba(255,255,255,0.8)',
            // borderColor: 'rgba(18, 36, 132, 1)',
            borderColor: '#292929',
            borderWidth: 1,
            textStyle: {
              color: '#050F37',
            },
          },
          grid: {
            left: "3%",
            right: "4%",
            bottom: "14%",
            top: "25%",
            containLabel: true,
          },
          xAxis: {
            type: "category",
            boundaryGap: true,
            data: [
              "4.29",
              "4.30",
              "5.1",
              "5.2",
              "5.3",
              "5.4",
              "5.5",
              "5.6",
              "5.7",
              "5.8",
              "5.9",
            ],
            axisLabel: {
              color: '#FFFFFF',
            },
            axisLine: {
              show: true, // X轴 网格线 颜色类型的修改
              lineStyle: {
                color: '#075F73',
              },
            },
            axisTick: {
              // X轴线 刻度线
              show: true,
              inside: true,
              alignWithLabel: true
            },
          },
          yAxis: {
            type: "value",
            name: '数量',
            nameTextStyle: {
              color: '#FFFFFF',
              padding: [3, 40, 0, 0],
              lineHeight: 45,
              // align:'left'
            },
            splitNumber: 3,
            axisLine: {
              show: false, // Y轴线
              lineStyle: {
                color: 'rgba(85, 193, 255, 1)',
              },
            },
            splitLine: {
              lineStyle: {
                type: 'dashed',
                color: 'rgba(255,255,255,0.05)'
              }
            },
            axisLabel: {
              color: '#FFFFFF',
            },
          },
          // yAxis: {
          //   type: "value",
          //   axisLine: {
          //     lineStyle: {
          //       color: "#2fa0bd",
          //     },
          //   },
          // },
          legend: {
            data: ["牛", "羊"],
            icon: "circle",
            top: "1%",
            right: "3%",
            itemWidth: 8,
            itemHeight: 8,
            padding: [10, 0, 0, 0],
            textStyle: { color: ["#2C76FE", "#00E0DB"] },
          },
          series: [
            {
              name: "牛",
              type: "line",
              stack: "总量",
              data: [90, 69, 95, 145, 184, 215, 252, 265, 233, 183, 139, 96],
              lineStyle: {
                color: "#2C76FE",
              },
            },
            {
              name: "羊",
              type: "line",
              stack: "总量",
              data: [39, 42, 57, 85, 119, 152, 170, 166, 142, 103, 66, 48],
              lineStyle: {
                color: "#00E0DB",
              },
            },
          ],
        });

        // 基于准备好的dom，初始化echarts实例
        let myChart6 = this.$echarts.init(document.getElementById("myChart6"));
        // 绘制图表
        myChart6.setOption({
          color: ["#0EDAE2", "#1EA3FE"],
          xAxis: {
            type: "category",
            boundaryGap: true,
            data: [
              "6月",
              "7月",
              "8月",
              "9月",
              "11月",
              "12月",
              "1月",
              "2月",
              "3月",
              "4月",
              "5月",
            ],
            axisLabel: {
              color: '#FFFFFF',
            },
            axisLine: {
              show: true, // X轴 网格线 颜色类型的修改
              lineStyle: {
                color: '#075F73',
              },
            },
            scale: false,
            axisTick: {
              // X轴线 刻度线
              // show: true,
              // inside: true,
              // alignWithLabel: true
              show: false,
            },
          },
          yAxis: {
            type: "value",
            name: '数量',
            nameTextStyle: {
              color: '#FFFFFF',
              padding: [3, 40, 0, 0],
              lineHeight: 45,
              // align:'left'
            },
            splitNumber: 3,
            axisLine: {
              show: false, // Y轴线
              lineStyle: {
                color: 'rgba(85, 193, 255, 1)',
              },
            },
            splitLine: {
              lineStyle: {
                type: 'dashed',
                color: 'rgba(255,255,255,0.05)'
              }
            },
            axisLabel: {
              color: '#FFFFFF',
            },
          },
          grid: {
            left: "3%",
            right: "4%",
            bottom: "14%",
            top: "25%",
            containLabel: true,
          },
          tooltip: {
            trigger: "axis",
            padding: [5, 20],
            backgroundColor: 'rgba(255,255,255,0.8)',
            // borderColor: 'rgba(18, 36, 132, 1)',
            borderColor: '#292929',
            borderWidth: 1,
            textStyle: {
              color: '#050F37',
            },
          },
          legend: {
            data: ["总消费", "贷款"],
            icon: "roundRect",
            top: "1%",
            right: "3%",
            itemWidth: 8,
            itemHeight: 8,
            padding: [10, 0, 0, 0],
            textStyle: { color: ["#0EDAE2", "#1EA3FE"] },
          },
          series: [
            {
              name: "总消费",
              data: [
                7, 6.9, 9.5, 14.5, 18.4, 21.5, 25.2, 26.5, 23.3, 18.3, 13.9,
                9.6,
              ],
              type: "bar",
              barWidth: 15,
              barGap: 0,
            },
            {
              name: "贷款",
              data: [
                3.9, 4.2, 5.7, 8.5, 11.9, 15.2, 17, 16.6, 14.2, 10.3, 6.6, 4.8,
              ],
              type: "bar",
              barWidth: 15,
              barGap: 0,
            },
          ],
        });

        // 基于准备好的dom，初始化echarts实例
        let myChart7 = this.$echarts.init(document.getElementById("myChart7"));
        // 绘制图表
        myChart7.setOption({
          color: ["#3AFFFB", "#FFC700", "#165DFF", "#7239EA", "#FF7300"],
          tooltip: {
            trigger: "item",
            formatter: "{b}: {c}%",
            backgroundColor: 'rgba(255,255,255,0.8)',
            borderColor: '#292929',
            borderWidth: 1,
            textStyle: {
              color: '#050F37',
            },
            padding: 5,
            extraCssText: "box-shadow: rgba(47, 244, 225, 0.5) 0px 0px 10px;",
          },
          legend: {
            data: ["固定资产", "生物资产", "长期资产", "流动资产", "其他资产"],
            icon: "circle",
            bottom: -5,
            textStyle: {
              color: '#00E0DB',
            },
            itemWidth: 10,
            itemHeight: 10,
          },
          series: [
            {
              name: "牧民资产",
              type: "pie",
              radius: ['40%', '70%'],
              bottom: 10,
              // itemStyle: {
              //   borderWidth: 1,
              //   borderColor: "#fff",
              // },
              label: {
                show: true,
                position: 'outside',
                color: '#FFFFFF',
                // padding: [0, -50],
                alignTo: 'labelLine',
                formatter: "{d}%\n{b}",
              },
              emphasis: {
                label: {
                  show: true,
                  // fontSize: '40',
                  // fontWeight: 'bold'
                }
              },
              labelLine: {
                show: true,
                length: 10,
                length2: 20,
                lineStyle: {
                  color: '#73c0de',
                }
              },
              data: [
                { value: 12.43, name: "固定资产" },
                { value: 12.26, name: "生物资产" },
                { value: 16.87, name: "长期资产" },
                { value: 25.75, name: "流动资产" },
                { value: 32.68, name: "其他资产" },
              ],
              // hoverAnimation: false,
            },
          ],
        });
      });
    },
    modelAdress(item) {
      this.currentAddress = item;
      this.$refs.pitchMap.showModel();
    },
    // 获取溯源信息
    getTraceSourceInfo() {
      // this.$http
      //   .get("/api.asmx/TraceSourceInfo")
      //   .then((res) => {
      //    if(res.data.code === 200 ) {
      //      console.log(JSON.parse(res.data.data));
      //      this.traceSourceInfo = JSON.parse(res.data.data);
      //      this.traceSourceInfo.map((item,index) => {
      //         item.no = index+1;
      //         return item
      //     })
      //     this.$nextTick(()=>{
      //       setInterval(this.timer, 1000);
      //       let this_ = this;
      //       let nodeList = this.$refs.lineBox.childNodes;
      //       this.elOffsetTopArr = [];
      //       for (let i = 0; i < nodeList.length; i++) {
      //         this_.elOffsetTopArr.push(nodeList[i].offsetTop);
      //       }
      //       this.listShow();
      //       // 滚动时监听
      //       window.onscroll = function () {
      //         this_.listShow();
      //       };
      //     })
      //    }
      //   });

      // this.traceSourceInfo = dataJson.chartInfo.data;
      this.traceSourceInfo.map((item, index) => {
        item.no = index + 1;
        return item
      })
      this.$nextTick(() => {
        setInterval(this.timer, 1000);
        let this_ = this;
        let nodeList = this.$refs.lineBox.childNodes;
        this.elOffsetTopArr = [];
        for (let i = 0; i < nodeList.length; i++) {
          this_.elOffsetTopArr.push(nodeList[i].offsetTop);
        }
        this.listShow();
        // 滚动时监听
        window.onscroll = function () {
          this_.listShow();
        };
      })
    },
    // 获取牧民视频
    getTraceSourceVideo(type) {
      // this.$http
      //   .get("/api.asmx/TraceSourceVideo",{
      //     params:{
      //       type: type
      //     }
      //   })
      //   .then((res) => {
      //    if(res.data.code === 200 ) {
      //    console.log(res.data.data);
      //    this.personVideoUrl = res.data.data
      //    }
      //   });
      if (type == 1) {
        this.personVideoUrl = 'http://www.91xumu.com/nxm-data/files/20201112143702_e8f2645429276fde1df7e692c230da87.mp4'
      } else {
        this.personVideoUrl = 'http://www.91xumu.com/nxm-data/files/20201112143859_qiye.mp4'
      }
    },
    setCameras() {
      // setTimeout(() => {
      const _this = this
      if (_this.decoder && _this.decoder.stop) {
        _this.decoder.stop()
        _this.decoder = {}
        // _this.camerasListItem = {}
        document.getElementById('myPlayer').innerHTML = ''
      }
      const w = this.$refs.device_box.offsetWidth
      const h = this.$refs.device_box.offsetHeight
      _this.$nextTick(() => {
        // if (document.getElementById('myPlayer')) document.getElementById('myPlayer').innerHTML = ''
        // _this.camerasListItem = item
        _this.decoder = new this.$EZUIKit.EZUIKitPlayer({
          id: 'myPlayer',
          url: 'ezopen://open.ys7.com/G13515883/12.hd.live',
          accessToken: 'at.6c3054nu3cubkj2hbrci3blu5jqi7hqb-6m3hqym5ax-0uih8ou-plfgkzo12',
          autoplay: true,
          audio: 0,
          decoderPath: '/ezuikit',
          width: w,
          height: h,
          splitBasis: 1,
        })
      })
      // this.videoModelShow = true
      // }, 5000)

    },
    setCameras1() {
      // setTimeout(() => {
      const _this = this
      if (_this.decoder1 && _this.decoder1.stop) {
        _this.decoder1.stop()
        _this.decoder1 = {}
        // _this.camerasListItem = {}
        document.getElementById('myPlayer1').innerHTML = ''
      }
      const w = this.$refs.device_box.offsetWidth
      const h = this.$refs.device_box.offsetHeight
      _this.$nextTick(() => {
        // if (document.getElementById('myPlayer')) document.getElementById('myPlayer').innerHTML = ''
        // _this.camerasListItem = item
        _this.decoder1 = new this.$EZUIKit.EZUIKitPlayer({
          id: 'myPlayer1',
          url: 'ezopen://open.ys7.com/AD4384838/1.hd.live',
          accessToken: 'at.37m8q02i9bwouidl8urv4ewy11xyyzr7-73tjfe9cn8-1yatk5x-e6fecldmh',
          autoplay: true,
          audio: 0,
          decoderPath: '/ezuikit',
          width: w,
          height: h,
          splitBasis: 1,
        })
      })
      // this.videoModelShow = true
      // }, 5000)

    },
  },
  beforeCreate() {
    // window.document.body.style.backgroundColor = "#001725";
  },
  beforeDestroy() {
    // window.document.body.style.backgroundColor = "#000";
  },
};
</script>
<style lang="scss" scoped>
.radio {
  width: 0.33rem;
  height: 0.33rem;
  background-color: rgba(253, 199, 65, 1);
  border-radius: 50%;
  left: -13px;
  position: absolute;
}

.main {
  position: relative;
  width: 100%;

  // height: 13.5rem;
  // min-height: 100vh;
  // background: url("../../assets/bg-hhr.png");
  // background-size: 100% 100%;
  .video_bg {
    position: fixed;
    top: 0;
    left: 0;
    z-index: -1;
    width: 100%;
    height: 100%;
  }

  .content-box {
    height: 13.5rem;
  }

  .line-box {
    width: 1px;
    border-left: 1px dashed #a4a8bb;
    border-right: 1px dashed #a4a8bb;
    // todo: transform: translate(50vw, 95px); 37.5vw
    position: absolute;
    left: 50%;
    transform: translate(50%, 95px);
    background: rgba(9, 14, 57, 1);

    /*padding-bottom: 30px;*/
  }

  .line-box li {
    color: #fff;
    font-size: 14px;
  }

  .line-box li .lis-box-t {
    display: inline-block;
    white-space: nowrap;
    transition: transform 1s;
    font-size: 18px;
  }

  .line-box li .lis-box-t div {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-right: 0.85rem;
  }

  .reset {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-right: 0.85rem;
    flex-direction: row-reverse;
  }

  .line-box li .lis-box-t p {
    margin: 14px;
    margin-top: -0.6rem;
  }

  .line-box li .lis-box-t img {
    width: 1.375rem;
    // height: auto;
    margin-top: -0.8rem;
  }

  .line-box li:nth-child(odd) .lis-box-t {
    transform-origin: 0 50%;
  }

  .line-box li:nth-child(odd) .lis-box-t div {
    margin-left: calc(-100% - 100px);
  }

  .line-box li:nth-child(even) .lis-box-t {
    transform-origin: 0 50%;
    width: 244.4px;
  }

  .line-box li:nth-child(even) .lis-box-t div {
    margin-left: -5px;
  }

  .line-box li:nth-child(odd) .lis-box-b {
    transform: translateX(calc(-100% - 10px));
  }

  .line-box li:nth-child(even) .lis-box-b {
    transform: translateX(10px);
  }

  .lis-box-b {
    display: inline-block;
    // width: 340px;
    width: 6.5rem !important;
    background-image: url("../../assets/trance_info_bg.png");
    background-repeat: no-repeat, no-repeat, no-repeat, no-repeat, no-repeat;
    background-position: 0 0, 100% 0, 0 100%, 100% 100%, 7px 7px;
    // background-size: 100px 63px,40px 40px,40px 40px,40px 40px,calc(100% - 13px) calc(100% - 13px);
    background-size: 100% 100%;
    position: relative;
    transition: transform 1s;
    padding-left: 10px;
    padding-bottom: 10px;
  }

  .line-box li:nth-child(odd) .lis-box-b.list-hide {
    transform: translateX(calc(-50vw - 100%));
    // transform: translateX( calc(-501w - 100%) );
  }

  .line-box li:nth-child(even) .lis-box-b.list-hide {
    transform: translateX(calc(50vw));
    // transform: translateX( calc(27vw) );
  }

  .line-box li:nth-child(odd) .lis-box-b.list-show {
    transform: translateX(calc(-100% - 10px));
  }

  .line-box li:nth-child(even) .lis-box-b.list-show {
    transform: translateX(10px);
  }

  .line-box li:nth-child(odd) .lis-box-t.list-hide {
    transform: rotateY(-90deg);
  }

  .line-box li:nth-child(even) .lis-box-t.list-hide {
    transform: rotateY(90deg);
  }

  .line-box li:nth-child(odd) .lis-box-t.list-show {
    transform: rotateY(0deg);
    transform-origin: 0 50%;
  }

  .line-box li:nth-child(even) .lis-box-t.list-show {
    transform: rotateY(0);
    transform-origin: 0 50%;
  }

  .card_item {
    display: flex;
    position: absolute;
    left: 0.26rem;
    top: 0.12199rem;
    font-size: 0.2rem;
    font-family: Source Han Sans CN-Bold, Source Han Sans CN;
    font-weight: bold;
    color: #00E0DB;

    .card {
      width: 0.11rem;
      height: 0.2rem;
      background: #00E0DB;
      margin-right: .15rem;
      align-items: center;
    }
  }

  .info_item {
    width: 8rem;
    // height: 2.38rem;
    height: 3.38rem;
    background: rgba(0, 223, 218, 0.04);
    border-radius: 0.13rem 0.13rem 0.13rem 0.13rem;
    opacity: 1;
    margin-top: .45rem;
    margin-left: -0.3rem;
    display: flex;
    align-items: center;
    padding-right: .2rem;

    .img_box {
      width: 1.25rem;
      height: 1.25rem;
      opacity: 1;
      // border: 0.04rem solid #FFFFFF;
      border-radius: 50%;
      margin-left: .29rem;

      img {
        width: 1.25rem;
        height: 1.25rem;
        border-radius: 50%;

      }
    }

    .info_ {
      height: 1.25rem;
      font-size: 0.18rem;
      font-family: Source Han Sans CN-Normal, Source Han Sans CN;
      font-weight: 400;
      color: #00E0DB;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      div {
        span:nth-child(2) {
          color: #FFFFFF;
        }
      }
    }


    .info_n {
      min-width: 2.1rem;
      margin-left: .29rem;
    }

    .info_a {
      min-width: 2.53rem;
      margin-left: .4rem;
      // justify-content: start;
    }
  }

  .title-text {
    position: absolute;
    // width: 85px;
    width: 118px;
    height: 22px;
    left: 0.26rem;
    // top: 0.1229rem;
    top: 0.12199rem;
    text-align: center;
    color: rgba(10, 18, 95, 1);
    font-size: 18px;
    font-weight: bold;
    line-height: 22px;
    background: url("../../assets/tran_title_bg.png");
    background-size: 100% 100%;
  }

  .text {
    min-width: 1.5rem;
    top: 2%;
    left: 46%;
    font-size: 0.3rem;
    font-family: Source Han Sans CN-Medium, Source Han Sans CN;
    font-weight: 500;
    color: #032929;
    background: none;
  }

  .lis-box-b>button {
    position: absolute;
    padding: 0 15px;
    height: 22px;
    right: 0.2rem;
    top: 0.3rem;
    text-align: center;
    font-size: 14px;
    font-weight: bold;
    line-height: 22px;
    background-color: transparent;
    border: none;
    color: #fff;
  }

  .img-box {
    width: 414px;
  }

  .info-box {
    display: flex;
    padding: 42px 23px 20px;
    flex: auto;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 40px;

    div {
      p {
        height: 0.3rem;
        font-size: 0.2rem;
        font-family: MicrosoftYaHei;
        color: #ffffff;
        line-height: 0.3rem;
      }

      /*  .title_number {
        font-family: Helvetica_1;
        font-size: 0.35rem;
      } */
    }

    #feedChart {
      width: 100%;
      height: 2.8rem;
    }
  }

  .info-box img {
    width: 2.8rem;
    height: 1.95rem;
    flex: none;
    margin-right: 0.125rem;
  }

  /*蒙版盒子*/
  .mask-box {
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    left: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 1);
    z-index: 2;
    /*display: none;*/
  }

  .modal-box {
    // width: 1290px;
    width: 21.62rem;
    max-height: 11.18rem;
    overflow: hidden;
    position: relative;
    color: #fff;
    padding: 50px .5rem;
    background: url('../../assets/table_bg.png');
    background-size: 100% 100%;
    // background: rgba(9, 14, 57, 1);
    // box-shadow: 0rem 0.03rem 0.28rem 0rem rgbargba(9, 14, 57, 0.5),
    //   inset 0rem 0.01rem 0.06rem 0rem rgba(9, 14, 57, 1);
    // border: 0.03rem solid rgb(13, 20, 85);

    .text-info {
      position: absolute;
      top: 0.35rem;
      left: 8.3rem;
      // display: flex;
      // justify-content: center;
      // align-items: center;
      // margin-top: -0.1rem;
      font-size: 0.3rem;
      font-family: Source Han Sans CN-Medium, Source Han Sans CN;
      font-weight: 500;
      color: #011128;
    }
  }

  .modal-box-1 {
    width: 18rem;
    // height: 10.28rem;
    height: 6.28rem;
    background: url('../../assets/traceInfo.png');
    background-size: 100% 100%;
    border: none;
    box-shadow: none;
  }

  .modal-box .el-icon-close {
    position: absolute;
    right: 0.38rem;
    top: 0.25rem;
    font-size: .4rem;
    color: #00E0DB;
    cursor: pointer;
  }

  .modal-box .icon-close {
    position: absolute;
    right: 0.38rem;
    top: 0.2rem;
    font-size: .3rem;
    color: #00E0DB;
  }

  .modal-box>div {
    display: flex;
  }

  .modal-box>div>div {
    flex: auto;
    width: 50%;
  }

  .modal-box .area-box {
    display: inline-block;
    width: 100%;
    background-repeat: no-repeat, no-repeat, no-repeat, no-repeat, no-repeat;
    background-position: 0 0, 100% 0, 0 100%, 100% 100%, 7px 7px;
    background-size: 100px 63px, 40px 40px, 40px 40px, 40px 40px,
      calc(100% - 13px) calc(100% - 13px);
    position: relative;
    transition: transform 1s;
    padding: 55px 45px 30px;
  }

  .modal-box2 .area-box {
    background-size: 118px 63px, 40px 40px, 40px 40px, 40px 40px,
      calc(100% - 13px) calc(100% - 13px);
  }

  .modal-box2 .title-text {
    width: 100px;
  }

  .modal-box .area-box p {
    line-height: 28px;
  }

  .area-box video {
    width: 100%;
    // height: 3.4rem;
    height: 4.4rem;
  }

  .consumer-list table {
    table-layout: fixed;
    width: 100%;
    font-size: .2rem;
  }

  .consumer-list table th {
    text-align: center;
    // padding-bottom: 24px;
    font-size: 0.18rem;
    font-family: Source Han Sans CN-Medium, Source Han Sans CN;
    font-weight: 500;
    color: #00E0DB;
  }

  .consumer-list table td {
    text-align: center;
    height: 50px;
    line-height: 50px;
    font-size: 0.15rem;
    font-family: Source Han Sans CN-Medium, Source Han Sans CN;
    font-weight: 500;
    color: #FFFFFF;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .consumer-list table tr th {
    height: 0.44rem;
    line-height: .44rem;
    padding: .1rem 0;
    background: rgba(255, 255, 255, 0.05);
  }

  .consumer-list table tbody tr:hover {
    // background: rgba(255, 255, 255, 0.05);
  }

  .consumer-list table tbody tr:nth-child(odd) {
    // background-color: rgba(53, 53, 89, 0.6);
    background: rgba(255, 255, 255, 0.05) !important;
  }

  .consumer-list table.consumer-lis-animate tbody tr:nth-child(even) {
    // background-color: rgba(53, 53, 89, 0.6);
  }

  .consumer-list table.consumer-lis-animate tbody tr:nth-child(odd) {
    // background-color: transparent;
  }

  .consumer-list table tr th:nth-child(1) {
    width: 10%;
    padding: .1rem 0;
    text-align: left !important;
    padding-left: 1rem !important;
  }

  .consumer-list table tr th:nth-child(2) {
    padding: .1rem 0;
    width: 6%;
  }

  .consumer-list table tr th:nth-child(3) {
    width: 16%;
    padding: .1rem 0;
    text-align: right !important;
    padding-right: 1rem !important;
  }

  .consumer-list table tr th:nth-child(4) {
    width: 18%;
    padding: .1rem 0;
    text-align: left !important;
    padding-left: 1rem !important;
  }

  .consumer-list table tr th:nth-child(5) {
    width: 20%;
  }

  .consumer-list table tr th:nth-child(6) {
    width: 30%;
  }

  .consumer-list table tbody tr td:nth-child(1) {
    padding: 0 30px;
    width: 10%;
    text-align: left !important;
    padding-left: 1rem !important;
  }

  .consumer-list table tbody tr td:nth-child(2) {
    width: 6%;
  }

  .consumer-list table tbody tr td:nth-child(3) {
    width: 16%;
    text-align: right !important;
    padding-right: 1rem !important;
  }

  .consumer-list table tbody tr td:nth-child(4) {
    width: 18%;
    padding: 0 20px;
    text-align: left !important;
    padding-left: 1rem !important;
  }

  .consumer-list table tbody tr td:nth-child(5) {
    width: 20%;
  }

  .consumer-list table tbody tr td:nth-child(6) {
    padding: 0 15px;
    width: 30%;
  }

  .consumer-list table img {
    width: 38px;
    height: 38px;
    vertical-align: inherit;
  }

  .consumer-lis-animate {
    transition: margin 1.9s;
  }

  .margin-t-35 {
    margin-top: -50px;
  }

  .pos-btn {
    position: fixed;
    right: 10%;
    bottom: 20%;
    background-color: transparent;
    border: none;
    outline: none;
    width: 40px;
    height: 40px;
    cursor: pointer;
    padding: 0;
  }

  .pos-btn img {
    width: 100%;
    height: 100%;
  }

  .area-box-btn {
    background-color: transparent;
    border: none;
    outline: none;
    font-size: 0.2rem;
    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
    font-weight: 400;
    color: #FFE11D;
    position: absolute;
    right: .4rem;
    top: 20px;
    cursor: pointer;
  }

  .position-relative {
    position: relative;
    top: 0;
    left: -0.4rem;
  }

  .time {
    position: absolute;
    width: 100%;
    height: 40px;
    top: 10px;
    left: 10px;
    // text-indent: 12%;
    text-indent: 5%;
    font-size: 20px;

  }
}

.pos-btn {
  position: fixed;
  right: 10%;
  bottom: 20%;
  background-color: transparent;
  border: none;
  outline: none;
  width: 40px;
  height: 40px;
  cursor: pointer;
  padding: 0;
}

.pos-btn img {
  width: 100%;
  height: 100%;
}


/* 滚动表格最外层 */

.tableoOut {
  // margin: 100px auto;
  width: 100%;
  height: 8.5rem;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding-bottom: .3rem;
}

.tableBox {
  width: 100%;
  overflow: hidden
}

.tableInner {
  height: auto;
}

.box {
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
}

.box .time {
  color: #858A84;
}

.tableoOut .addr,
.tableoOut .time,
.tableoOut .name {
  box-sizing: border-box;
  padding: 0 5px;
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.tableoOut .addr {
  width: calc(100% - 200px);
  flex-shrink: 0;
}

.tableoOut .name,
.tableoOut .time {
  width: 100px;
  flex-shrink: 0;
}

.model_box {
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 1);
  z-index: 2;

  .active {
    color: #000000 !important;
    background-color: #23fff9 !important;

    &::after {
      position: absolute;
      // left: 1.9rem;
      left: 2.15rem;
      top: 0;
      content: "";
      display: block;
      // border: .28rem solid transparent;
      // border-right: 0.28rem solid #23fff9 !important;
      // border-top: 0.28rem solid #23fff9 !important;
      border-width: 0.28rem 0.16rem;
      border-style: solid;
      border-color: #23fff9 #23fff9 transparent transparent;
    }
  }

  .active1 {
    background-color: #23fff9 !important;
    color: #000000 !important;
  }

  .model_content {
    position: relative;
    // position: fixed;
    // top: -1rem;
    // left: 50%;
    // transform: translate(-5rem,-4rem);
    // width: 11.54rem;
    width: 21.62rem;
    max-height: 11.1rem;
    // background: rgba(7, 70, 73, 0.95);
    // box-shadow: 0rem 0.03rem 0.28rem 0rem rgba(47, 244, 225, 0.5), inset 0rem 0.01rem 0.06rem 0rem #08DAC8;
    // border: 0.03rem solid #01FAFF;
    // background: url('../../assets/map_bg.png');
    background: url('../../assets/map_list.png');
    background-size: 100% 100%;
    // padding: 0.3rem .88rem;
    padding: 0 30px 30px;

    .top_box {
      width: 100%;
      height: .56rem;
      position: absolute;
      top: 0;
      left: 0;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .left_box {
        position: relative;
        display: flex;
        cursor: pointer;
        background-color: #041a1e;
        margin-bottom: 0.025rem;

        &::after {
          position: absolute;
          // left: 4.35rem;
          left: 4.58rem;
          top: 0;
          content: "";
          display: block;
          // border: .28rem solid transparent;
          // border-right: 0.28rem solid #000000;
          // border-top: 0.28rem solid #000000;
          border-width: 0.28rem 0.16rem;
          border-style: solid;
          border-color: #000000 #000000 transparent transparent;
        }

        .saoma {
          width: 2.44rem;
          height: 0.56rem;
          color: #3dbab0;
          font-size: 0.23rem;
          font-family: Microsoft YaHei-Regular, Microsoft YaHei;
          font-weight: 400;
          text-align: center;
          line-height: .56rem;
          border-radius: 10px 0 0 0;

          span {
            margin-right: .3rem;
          }

          &::after {
            position: absolute;
            left: 2.15rem;
            top: 0;
            content: "";
            display: block;
            /* border: 0.28rem solid transparent; */
            /* border-right: 0.28rem solid #041a1e; */
            /* border-top: 0.28rem solid #041a1e; */
            border-width: 0.3rem 0.16rem;
            border-style: solid;
            border-color: #041a1d #041a1d transparent transparent;
          }
        }



        .hotMap {
          width: 2.44rem;
          height: 0.56rem;
          color: #3dbab0;
          font-size: 0.23rem;
          font-family: Microsoft YaHei-Regular, Microsoft YaHei;
          font-weight: 400;
          text-align: center;
          line-height: .56rem;

          span {
            margin-left: -0.5rem;
          }
        }
      }

      .el-icon-close {
        width: 0.25rem;
        height: 0.25rem;
        color: #00E0DB;
        font-size: .25rem;
        cursor: pointer;
      }
    }

    .saoma_list {
      width: 20.88rem;
      height: 10.38rem;
      margin-top: 1rem;
    }

    .line_box {
      position: relative;
      margin-top: .85rem;
      width: 20.88rem;
      height: 10rem;
      border: 0.01rem solid rgba(0, 224, 219, 0.2);
      padding: 0 .25rem;

      &::after {
        position: absolute;
        left: 0;
        top: 0;
        content: "";
        width: 0.36rem;
        height: 0.36rem;
        opacity: 1;
        border-left: 0.02rem solid #23fff9;
        border-top: 0.02rem solid #23fff9;
      }

      &::before {
        position: absolute;
        right: 0;
        top: 0;
        content: "";
        width: 0.36rem;
        height: 0.36rem;
        opacity: 1;
        border-top: 0.02rem solid #23fff9;
        border-right: 0.02rem solid #23fff9;
      }

      .bottom_box {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: .3rem;

        &::after {
          position: absolute;
          left: 0;
          bottom: 0;
          content: "";
          width: 0.36rem;
          height: 0.36rem;
          opacity: 1;
          border-left: 0.02rem solid #23fff9;
          border-bottom: 0.02rem solid #23fff9;
        }

        &::before {
          position: absolute;
          right: 0;
          bottom: 0;
          content: "";
          width: 0.36rem;
          height: 0.36rem;
          opacity: 1;
          border-bottom: 0.02rem solid #23fff9;
          border-right: 0.02rem solid #23fff9;
        }
      }
    }

    // transform: translate(0, -3%);
    .text {
      position: absolute;
      top: 0.25rem;
      left: 45.5%;
      font-size: 0.3rem;
      font-family: Source Han Sans CN-Medium, Source Han Sans CN;
      font-weight: 500;
      color: #032929;
    }

    .title {
      display: flex;
      justify-content: flex-end;
      align-items: center;

      .el-icon-close {
        // position: absolute;
        // right: 0.38rem;
        // top: 0.25rem;
        font-size: .4rem;
        color: #00E0DB;
        cursor: pointer;
        margin-right: -0.55rem;
      }

      span {
        position: absolute;
        top: 0.9rem;
        right: .85rem;
        font-size: 0.2rem;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #FFE11D;
        cursor: pointer;
      }

      img {
        width: 0.28rem;
        height: 0.28rem;
        cursor: pointer;
      }

      .title-text {
        width: 100px;
        height: 22px;
        line-height: 22px;
        font-size: 14px;
        font-weight: bold;
        cursor: pointer;
        background: url("../../assets/tran_title_bg.png");
        background-size: 100% 100%;
      }
    }

    .changeList {
      color: #08DAC8;
      position: absolute;
      top: 0.5rem;
      right: 0.5rem;
      cursor: pointer;
      font-size: .2rem;
    }

    .line_box {}

    .map_box {
      margin-top: .05rem;
      display: flex;
      justify-content: center;
    }

    .bm-view {
      margin-top: 0.2rem;
      width: 100%;
      height: 9.46rem;

      ::v-deep .BMap_cpyCtrl {
        display: none !important;
      }
    }

    // .amap-layers{
    //     cursor: pointer!important;
    // }
  }

}
</style>